import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { CollectionPaths } from '@models/collections';
import { GlobalEmailTemplateMetadata } from '@models/global-email-templates';
import { Repo } from '../../repo.service';

@Injectable({
	providedIn: 'root',
})
export class GlobalEmailTemplatesRepo extends Repo<
	GlobalEmailTemplateMetadata,
	null
> {
	constructor(private firestore: AngularFirestore) {
		super(firestore);
	}

	GetCollectionPath(): string {
		return CollectionPaths.global_email_templates();
	}
}
